import PropsType from "prop-types";
import NavLink from "./NavLink";
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";

function Breadcrumbs(props) {
    const { items = [] } = props;

    return (
        <>
            <MuiBreadcrumbs sx={{ my: 1 }} aria-label="breadcrumb">
                {items.map((item, index) => (
                    <NavLink key={index} {...item} />
                ))}
            </MuiBreadcrumbs>
        </>
    );
}

Breadcrumbs.propsType = {
    items: PropsType.array,
};

export default Breadcrumbs;
